import { getAuditIdFromURL } from 'utils/browser'
import { MAIN_MENU_ITEMS, AUDIT_MENU_ITEMS } from 'constants/MenuItems'

export const getItemList = (pathname) =>
  getAuditIdFromURL(pathname) !== null ? AUDIT_MENU_ITEMS : MAIN_MENU_ITEMS
